import Promise from 'bluebird';
import _ from 'lodash';

import store from '../../store';
import { OVERVIEW_PANEL_GET_CURRENT, OVERVIEW_PANEL_IS_VISIBLE } from '../../store/modules/overview-panel/types';

import api from '../api';
import filters from '../core/filters';
import worldMap from '../core/map';
import { pinBuilder } from '../core/map/pinBuilder';
import templates from '../core/templates';
import ColorBrewer from '../core/tools/colorbrewer';
import environment from '../environment';
import { NOTIFY_TYPE, notifyError } from "../shared/notify";
import Leaflet from './Leaflet';

import { ContextEnum } from '../../enuns/context.enum';
import Storage from '../storage';
// import 'mapbox.js';
const LayerControls = name => require('../controls').get(name);
const LayerInfo = (name) => require('../info').get(name);
const get = (name, currentMap = worldMap.getCurrent()) => {
    return require('./index').default.get(name, currentMap);
};

import { FeaturePermission } from '../../constants/feature.permission.helper';
import { translateText } from '../core/tools/translate';
const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

const name = 'DirectSales';

class DirectSalesLayer {
    constructor(currentMap) {
        // let _total = 0;
        const mapId = +currentMap._id;

        const clusterImage = new Image();
        clusterImage.src = `${environment.get('IMAGES_HOST')}/icon_marker_direct_sales.png`;

        const colors = [
            '#FF5722',
            '#9C27B0',
            '#3F51B5',
            '#03A9F4',
            '#009688',
            '#8BC34A',
            '#FFC107',
            '#f44336',
            '#673AB7',
            '#2196F3',
            '#00BCD4',
            '#4CAF50',
            '#CDDC39',
            '#FF9800',
            '#E91E63',
        ];

        const colorByChannel = _.reduce(environment.get('CONFIG.FILTERS.SALES_CHANNEL'), (acc, val, idx) => {
            acc[val.value] = colors[idx % colors.length];
            return acc;
        }, {});

        const clusterTemplate = cluster => {
            // if (!_total) {
            //     _total = _.sumBy(get(name, currentMap).getCurrentFeatures(), p =>
            //         _.sumBy(p.properties.DirectSales, 'qtdSales')
            //     );
            // }

            const data = {
                percent: [],
                colors,
                // total: _total,
                value: 0
            };

            let total = 0;
            const categories = {};
            const order = _.map(environment.get('CONFIG.FILTERS.SALES_CHANNEL'), i => 0);

            _.forEach(environment.get('CONFIG.FILTERS.SALES_CHANNEL'), (val, i) => {
                order[i] = val.value;
            });

            _.forEach(cluster.getAllChildMarkers(), (marker) => {
                if (marker.feature) {
                    total += marker.feature.properties.Value;
                    _.forEach(marker.feature.properties.DirectSales, d => {
                        categories[d.idSaleChannelAggregate] = (categories[d.idSaleChannelAggregate] || 0) + d.qtdSales;
                    });
                }
            });

            if (total > 0) {
                _.forEach(order, id => data.percent.push(((categories[id] || 0) / total) || 0));
                data.value = total;
            }

            return pinBuilder.create.pin.imageWithValue(data, clusterImage);
        };

        const onComplete = () => {
            if (
                store.getters[OVERVIEW_PANEL_GET_CURRENT] === name &&
                store.getters[OVERVIEW_PANEL_IS_VISIBLE] &&
                LayerControls(name).getControls(mapId).button.overview.enable
            ) {
                LayerControls(name).toggleOverview();
            }
            // _total = 0;
        };

        const onSuccess = res =>
            new Promise((resolve, reject) => {
                const features = res.features;
                // obs: models are segments.
                const filterData = _.assign(
                    { channels: {}, companySizes: {}, brands: {}, models: {}, group: {}, dealer: {}, fuelTypes: {} },
                    filters.get(`filters-${mapId}`, mapId)
                );

                if (!filterData.brands || !filterData.brands.value) {
                    filterData.brands.value = _.uniq(environment.get('CONFIG.FILTERS.BRANDS').map(x => x.brandId));
                }

                if (!filterData.models.value && filterData.competingClassification && _.size(filterData.competingClassification.value)) {
                    filterData.models.value = _.flatMap(filterData.competingClassification.value, key => _.map(environment.get('CONFIG.FILTERS.COMPETING_SEGMENTS')[key], 'id'));
                }

                const options = {
                    idLocalidades: _.map(features, f => f.properties.Id),
                    idTipoLocalidade: LayerControls(name).getType(),
                    idSalesChannelAggregate: filterData.channels.value,
                    companySizes: filterData.companySizes.value,
                    idBandeiras: filterData.brands.value,
                    idEconomicGroup: filterData.group.value,
                    idStores: filterData.dealer.value,
                    idSegments: filterData.models.value,
                    IdFuelTypes: filterData.fuelTypes.value,
                    anoMesInicio: LayerControls(name)
                        .getDate(currentMap._id)
                        .start.format('YYYYMM'),
                    anoMesFim: LayerControls(name)
                        .getDate(currentMap._id)
                        .end.format('YYYYMM'),
                    tipoVenda: 2
                };

                if (filterData.industry && filterData.industry.value) {
                    options.idIndustry = _.isArray(filterData.industry.value)
                        ? filterData.industry.value.map(x => x.toString())
                        : [filterData.industry.value.toString()];
                }

                LayerControls(name).updateLegend(features[0].properties.Tipo);

                Storage.save(`options-directSales-${mapId}`, options);
                api.general.log.action(ContextEnum.LayerDirectSale, 'Params', JSON.stringify(options));

                api.themes.get.areas.directSales(options)
                    .then(res => {
                        if (!_.size(res) || !_.some(res, r => r.valor !== 0)) {
                            const message = { type: NOTIFY_TYPE.LOG, text: 'Não existem dados para o filtro selecionado' };
                            notifyError(null, message);
                        }

                        const fc = {
                            destroy: true,
                            type: 'FeatureCollection',
                            features: _.map(features, f => {
                                const directSales = _.filter(res, r => r.idLocale === f.properties.Id) || [];
                                f.properties.Value = _.sumBy(directSales, 'qtdSales');
                                f.properties.DirectSales = directSales;
                                return f;
                            })
                        };
                        return resolve(fc);
                    });
            });

        // const onClick = (feature, layer) => {
        //     try {
        //         $(`#DirectSales-selection-${feature.properties.Id}`).iCheck(LayerInfo(name).check(feature.properties.Id) ? 'uncheck' : 'check');
        //     }catch (err) {
        //         console.log('ERROR onClick: ', err);
        //     }

        // };

        const inverse = true;
        /* let inverse;
         if (isAuthorized('dynamic-maps-DirectSales-expansion-view')) {
         inverse = false;
         } else if (isAuthorized('dynamic-maps-DirectSales-sales-view')) {
         inverse = true;
         } */

        const ignore = value => Number(value) < 0;
        /* const ignore = (value) => {
         if (isAuthorized('dynamic-maps-DirectSales-expansion-view')) {
         return Number(value) < 0;
         } else if (isAuthorized('dynamic-maps-DirectSales-sales-view')) {
         return Number(value) > 0;
         }
         }; */

        const layer = new Leaflet.GeoJSONLayer();

        layer.setOptions({
            map: currentMap,
            remote: {
                url: `${environment.get('API_HOST')}/localidade/GetLocation`,
                params: {
                    locationType: environment.get('TYPE.AUTO'),//3,
                    format: 'topojson'
                }
            },
            filter: {
                location: true,
                properties: {
                    Value: '!0'
                }
            },
            cache: true,
            scaleRange: new Leaflet.ZoomLevel(layer, {
                id: environment.get('TYPE.AUTO'),
                property: 'locationType',
                areas: environment.get('CONFIG.FILTERS.DIRECT_TYPES')
            }),
            expandView: 0.3,
            showAll: false,
            uniqueField: 'Id',
            value: 'Value',
            success: onSuccess,
            done: onComplete,
            // click: onClick,
            sort: 'Nome',
            popup: {
                trigger: 'mouseover',
                template(properties, layer) {
                    // if (worldMap.getZoom() < 2) return;

                    const layerType = LayerControls(name).getControls(mapId).buttonGroup.layerType.type;

                    if (layerType === 'decluster') {
                        this.options.offset = L.point(0, -16);
                    } else {
                        this.options.offset = L.point(0, -50);
                    }

                    return new Promise((resolve, reject) => {
                        const total = _.sumBy(properties.DirectSales, 'qtdSales');

                        const data = _(properties.DirectSales)
                            .groupBy(item => item.nameSaleChannelAggregate)
                            .map((item, key) => {
                                return {
                                    id: item[0].idStoreClient,
                                    value: _.sumBy(item, 'qtdSales'),
                                    percent: _.sumBy(item, 'qtdSales') / total,
                                    text: translateText(key, true),
                                    textTruncate: _.truncate(translateText(key, true), { length: 17 }),
                                    color: colorByChannel[item[0].idSaleChannelAggregate]
                                };
                            })
                            .orderBy(item => item.value)
                            .reverse()
                            .value();

                        if (!isAuthorized(FeaturePermission.LAYER_DIRECT_SALE.showDataPanel)) {
                            const template = $(
                                templates('map-layer-general-label', { title: translateText(properties.Nome, true) })
                            );

                            return resolve(template);
                        }

                        const template = $(
                            templates('map-layer-clients-cluster-popup-alt', { clients: data, title: translateText(properties.Nome, true) })
                        );

                        setTimeout(() => {
                            $('#map-popup-chart').kendoChart({
                                title: {
                                    text: ''
                                },
                                dataSource: { data: _.filter(data, d => parseFloat(d.value) > 0) },
                                seriesColors: _.map(data, d => d.color),
                                seriesDefaults: {
                                    labels: {
                                        position: 'center',
                                        visible: true,
                                        background: 'transparent',
                                        format: '{0}',
                                        font: 'bold 10px "Roboto Condensed", sans-serif',
                                        color: '#FFF'
                                    }
                                },
                                theme: 'bootstrap',
                                chartArea: {
                                    width: 260,
                                    height: 140,
                                    margin: {
                                        top: 0,
                                        bottom: 0,
                                        left: 10,
                                        right: 10
                                    }
                                },
                                legend: {
                                    position: 'right',
                                    labels: {
                                        font: '10px "Roboto Condensed", sans-serif'
                                    }
                                },
                                series: [
                                    {
                                        type: 'pie',
                                        field: 'value',
                                        categoryField: 'textTruncate'
                                    }
                                ]
                            });
                        }, 300);

                        resolve(template);
                    });
                },
                options: {
                    offset: L.point(0, -16),
                    closeButton: false,
                    autoclose: true
                },
                single: true
            },
            type: 'cluster_area',
            symbology: {
                type: 'single',
                cluster: {
                    theme: ColorBrewer[ColorBrewer.RED_WHITE_BLUE][9],
                    template: clusterTemplate,
                    force: true
                },
                heat: {
                    theme: ColorBrewer.getHeatColors(ColorBrewer.RED_WHITE_BLUE),
                    property: 'Value',
                    scale: 'jenks',
                    inverse,
                    ignore
                },
                style: {
                    lineJoin: 'round',
                    highlight: ColorBrewer[ColorBrewer.RED_WHITE_BLUE][9][8],
                    color: 'transparent',
                    fillColor: 'transparent',
                    fillOpacity: 0.4,
                    weight: 1.2
                }
            }
        });
        return layer;
    }
}

export default DirectSalesLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/DirectSalesLayer.js